import LawFirmDetails from './LawFirmDetails';

export default LawFirmDetails;
